"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Creates a try catch for a web worker around a script.
 *
 * @param {string} originalScript The script to put a try-catch around.
 * @returns {string} The new script including a try-catch.
 */

function createExceptionHandler(originalScript) {
  return "\n\t\ttry {\n\t\t\t".concat(originalScript, "\n\t\t} catch ( error ) {\n\t\t\tconsole.log( \"Error occured during worker initialization:\" );\n\t\t\tconsole.log( error );\n\t\t}\n\t");
}
/**
 * Creates the script to run inside the fallback web worker.
 *
 * @param {string} url The URL for which to create a script.
 * @returns {string} A script that can be run inside a worker as a blob.
 */


function createBlobScript(url) {
  return "\n\t\tself.yoastOriginalUrl = '".concat(url, "';\n\t\timportScripts('").concat(url, "');\n\t");
}
/**
 * Determines whether or not two URLs have the same origin.
 *
 * @param {string} urlA First URL to test.
 * @param {string} urlB Second URL to test.
 *
 * @returns {boolean} Whether the URLs have the same origin.
 */


function isSameOrigin(urlA, urlB) {
  urlA = new URL(urlA, window.location.origin);
  urlB = new URL(urlB, window.location.origin);
  return urlA.hostname === urlB.hostname && urlA.port === urlB.port && urlA.protocol === urlB.protocol;
}
/**
 * Creates an URL to a blob. This blob imports a script for use in a web worker (using `importScripts`).
 *
 * @param {string} url The URL to the script that has to be loaded.
 * @returns {string} the URL to the blob.
 */


function createBlobURL(url) {
  var URL = window.URL || window.webkitURL;
  var BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder;
  var blobScript = createExceptionHandler(createBlobScript(url));
  var blob;

  try {
    blob = new Blob([blobScript], {
      type: "application/javascript"
    });
  } catch (e1) {
    var blobBuilder = new BlobBuilder();
    blobBuilder.append(blobScript);
    blob = blobBuilder.getBlob("application/javascript");
  }

  return URL.createObjectURL(blob);
}
/**
 * Creates a worker fallback using the blob URL method.
 *
 * @param {string} url The URL to create a worker for.
 * @returns {Worker} The web worker.
 */


function createWorkerFallback(url) {
  var blobUrl = createBlobURL(url);
  return new Worker(blobUrl);
}
/**
 * Creates a WebWorker using the given url.
 *
 * @param {string} url The url of the worker.
 *
 * @returns {Worker} The worker.
 */


function createWorker(url) {
  // If we are not on the same domain, we require a fallback worker.
  if (!isSameOrigin(window.location, url)) {
    return createWorkerFallback(url);
  }

  var worker = null;

  try {
    worker = new Worker(url);
  } catch (e) {
    try {
      worker = createWorkerFallback(url);
    } catch (e2) {
      throw e2;
    }
  }

  return worker;
}

exports.default = createWorker;